export enum SlideToggleSize {
  s = 's',
  l = 'l',
}
